require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/es7.symbol.observable.js
// module id = 267
// module chunks = 0